<template>
	<div>
		<SupportBanner />
		<div class="content-zsy" v-loading="loading" style="min-height: 400px;">
			<div class="column-center" v-if="info">
				<h3>이벤트</h3>
				<div class="content-title" >
					{{info.title}}
				</div>
				<div class="content-date">
					{{info.createtime}} / {{info.nickname}}
				</div>
				<div class="content" v-html="info.content">	
				</div>
				<div class="content-bottom">
					<el-button @click="onEventList">글목록</el-button>
				</div>
			</div>	
		</div>
		
	</div>
</template>

<script>
	import SupportBanner from '../../components/SupportBanner.vue'
	import request from '@/utils/request';
	export default {
		components: {
			SupportBanner,
		},
		props: ['id'],
		data() {
			return {
				loading: true,
				info: null,
			}
		},
		created() {
			this.getDetail()
		},
		methods: {
			getDetail(){
				this.loading = true
				request.post('/Activity/getActivityDetail',
					{
						id:this.id,
					}
				).then(res => {
					this.loading = false
					console.log(res.data,"xq")
					if(res.code ==1){
						this.info = res.data
					}			
				}).catch(() => {
					this.loading = false
				});
			},
			onEventList(){
				this.$router.push(`/boardEvent`)
			}
			
		}
	}
</script>

<style scoped>
	.column-center h3 {
	    text-align: center;
	    font-size: 45px;
	    font-weight: bold;
	    color: var(--frontground-color);
	    padding: 60px 0 0 0;
	    margin: 0 0 60px;
	}
	.content-title{
		font-size: 24px;
		border-top: 2px solid #000;
		text-align: left;
		padding: 13px 15px;
		font-weight: 500;
		/* background-color: #f5f8fd; */
	}
	.content-date{
		padding: 20px 15px;
		color: #6a6a6a;
		border: solid 1px var(--border-color);
		border-width: 1px 0;
	}
	.content{
		padding: 20px 15px;
		border: solid 1px var(--border-color);
		border-width: 0 0 1px 0;
		background-color: var(--frontground-color);
	}
	.content-bottom{
		padding:20px;
		display: flex;
		justify-content: end;
	}
	
	
	@media (min-width: 992px) {
		.content-zsy{
			width: 1270px;
			margin: 2.5rem auto;
		}
	}
</style>